export default {
    emits: ["update:modelValue"],
    data() {
        return {
            value: this.modelValue,
            mensagemCampoObrigatorio: "Value é obrigatório",
        };
    },
    watch: {
        modelValue: function (valorNovo) {
            this.value = valorNovo;
        },
        value: function (valorNovo) {
            this.$emit("update:modelValue", valorNovo);
        },
    },
    computed: {
        setClass() {
            return {
                "p-invalid": this.temErro,
            };
        },
        obterMensagemCampoObrigatorio() {
            if (this.label == "Data de nascimento *")
                return "Data de nascimento precisa ser válida"
            else
                return this.mensagemCampoObrigatorio.replace("Value", this.label.replace('*', '').replace('?', '').trim());
        },
        getClassDiv() {
            return `field ${this.classDiv}`;
        },
    },
    methods: {
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        },

        formatDate(date) {
            return [
                date.getFullYear(),
                this.padTo2Digits(date.getMonth() + 1),
                this.padTo2Digits(date.getDate()),
            ].join('-');
        },
        
        validarData(value) {
            if (value.replace(/[^0-9]/g,'').length == 8) {
    
                const dataArray = value.split("/");
                var data = new Date(dataArray[2], dataArray[1] - 1, dataArray[0])

                data = this.formatDate(data)
                var dataAtual = this.formatDate(new Date())
                var dataMinima = this.formatDate(new Date(1900, 1-1, 1))

                if(data >= dataAtual)
                    return false
                    
                if (data < dataMinima)
                    return false

                return true
            }
            
            return false
        },

        validarCPF(strCPF) {            
            if ((strCPF != null) && (strCPF.replace(/[^0-9]/g,'').length == 11)) {

                var Soma = 0
                var Resto
                var i
                strCPF = strCPF.replace(/[^\d]/g, '')

                if ([
                    '00000000000',
                    '11111111111',
                    '22222222222',
                    '33333333333',
                    '44444444444',
                    '55555555555',
                    '66666666666',
                    '77777777777',
                    '88888888888',
                    '99999999999',
                    ].indexOf(strCPF) !== -1)
                    return false

                for (i=1; i<=9; i++)
                    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (11 - i)
                  
                Resto = (Soma * 10) % 11

                if ((Resto == 10) || (Resto == 11)) 
                    Resto = 0

                if (Resto != parseInt(strCPF.substring(9, 10)) )
                    return false

                Soma = 0

                for (i = 1; i <= 10; i++)
                    Soma = Soma + parseInt(strCPF.substring(i-1, i)) * (12 - i)
                
                Resto = (Soma * 10) % 11

                if ((Resto == 10) || (Resto == 11)) 
                    Resto = 0

                if (Resto != parseInt(strCPF.substring(10, 11) ) )
                    return false

                return true
            }

            return false
        }
    }
}